// Core
import { Flex, Text, useColorModeValue } from '@chakra-ui/react';

// Components
import { StarsIcon } from 'components/Icons/Icons';

const List = ({ text }) => {
    const textColor = useColorModeValue('#0E1633', 'white');

    return (
        <Flex gap="12px" mt="16px">
            <StarsIcon fontSize="16px" mt="2px" />
            <Text color={textColor}>{text}</Text>
        </Flex>
    );
};


export default List;